import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Linkedin, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  const offices = [
    { city: 'Vila Velha/ES', type: 'Matriz', address: 'Rua Sete de Junho, 33, Sala 506, Coqueiral de Itaparica – CEP 29.102-310' },
    { city: 'Belo Horizonte/MG', type: 'Filial', address: 'Rua Tomé de Souza, 830, Sala 1602, Savassi – CEP 30.140-136' },
    { city: 'Itajaí/SC', type: 'Filial', address: 'Rua Samuel Heusi, nº 463, Sala 606, Centro – CEP 88.301-320' },
    { city: 'São Paulo/SP', type: 'Filial', address: 'Av. Paulista, 1439, Ed. Mario Wallace Simonsen, 1º andar, cj 12 – CEP 01.311-200' },
  ];

  return (
    <footer className="bg-[#1a1a1a] dark:bg-black text-white py-16 md:py-20 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Logo */}
        <div className="flex justify-center mb-12">
          <Link to="/" className="flex items-center gap-3 group cursor-pointer">
            <img 
              src="/assets/logo-wellcargo-white.png" 
              alt="Well Cargo" 
              className="h-12 md:h-14 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>
        </div>

        {/* Offices Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {offices.map((office, index) => (
            <div key={index} className="text-center md:text-left p-4 rounded-xl hover:bg-white/5 transition-colors">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                <MapPin className="w-4 h-4 text-[#3ECDA3]" />
                <p className="text-white font-medium text-sm">{office.city}</p>
                <span className="text-[#3ECDA3] text-xs px-2 py-0.5 bg-[#3ECDA3]/10 rounded-full">
                  {office.type}
                </span>
              </div>
              <p className="text-gray-400 text-xs leading-relaxed">
                {office.address}
              </p>
            </div>
          ))}
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-800 pt-8 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Phone Principal */}
            <a href="tel:+5527997580648" className="flex items-center gap-3 justify-center text-gray-400 hover:text-[#3ECDA3] transition-colors bg-[#3ECDA3]/10 rounded-xl p-4 border border-[#3ECDA3]/30">
              <Phone className="w-6 h-6 text-[#3ECDA3]" />
              <div>
                <p className="text-[#3ECDA3] font-bold text-base">+55 27 99758-0648</p>
                <p className="text-[#3ECDA3]/70 text-xs font-medium">Principal</p>
              </div>
            </a>

            {/* Phone Fixo */}
            <a href="tel:+552735342660" className="flex items-center gap-3 justify-center text-gray-400 hover:text-[#3ECDA3] transition-colors">
              <Phone className="w-5 h-5 text-[#3ECDA3]" />
              <div>
                <p className="text-white font-medium text-sm">+55 27 3534-2660</p>
                <p className="text-gray-500 text-xs">Fixo</p>
              </div>
            </a>

            {/* Phone Celular */}
            <a href="tel:+5527999744514" className="flex items-center gap-3 justify-center text-gray-400 hover:text-[#3ECDA3] transition-colors">
              <Phone className="w-5 h-5 text-[#3ECDA3]" />
              <div>
                <p className="text-white font-medium text-sm">+55 27 99974-4514</p>
                <p className="text-gray-500 text-xs">Celular</p>
              </div>
            </a>

            {/* Email */}
            <a href="mailto:sales@wellcargo.com.br" className="flex items-center gap-3 justify-center text-gray-400 hover:text-[#3ECDA3] transition-colors">
              <Mail className="w-5 h-5 text-[#3ECDA3]" />
              <div>
                <p className="text-white font-medium text-sm">sales@wellcargo.com.br</p>
                <p className="text-gray-500 text-xs">E-mail</p>
              </div>
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            {t('footer.copyright')}
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#3ECDA3] transition-all duration-300 hover:scale-110"
            >
              <Linkedin size={20} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#3ECDA3] transition-all duration-300 hover:scale-110"
            >
              <Facebook size={20} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#3ECDA3] transition-all duration-300 hover:scale-110"
            >
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
